import { useEffect, useMemo, useState } from 'react'

import { fetchOrganizationMembershipsByUserUuids } from 'shared/api/organization_memberships'
import {
  buildOwnersByUserUuid,
  getOwnerUserUuidsForLookup,
} from 'shared/utils/owner_display_name'

export const useBatchedOwnerDisplayNames = ({ meetings, enabled, currentUserUuid }) => {
  const [ownersByUuid, setOwnersByUuid] = useState({})

  const ownerUserUuids = useMemo(() => (
    enabled ? getOwnerUserUuidsForLookup(meetings, currentUserUuid) : []
  ), [meetings, enabled, currentUserUuid])

  // This is to make the dependency array for the useEffect unique
  const ownerUserUuidsKey = useMemo(
    () => [...ownerUserUuids].sort().join(','),
    [ownerUserUuids],
  )

  useEffect(() => {
    if (!ownerUserUuidsKey) {
      setOwnersByUuid((prev) => (Object.keys(prev).length === 0 ? prev : {}))
      return undefined
    }

    const uuidsToFetch = ownerUserUuidsKey.split(',')
    let cancelled = false

    fetchOrganizationMembershipsByUserUuids(uuidsToFetch)
      .then((memberships) => {
        if (!cancelled) {
          setOwnersByUuid(buildOwnersByUserUuid(memberships))
        }
      })
      .catch(() => {
        if (!cancelled) {
          setOwnersByUuid((prev) => (Object.keys(prev).length === 0 ? prev : {}))
        }
      })

    return () => {
      cancelled = true
    }
  }, [ownerUserUuidsKey])

  return ownersByUuid
}
